import { render, staticRenderFns } from "./grant.vue?vue&type=template&id=3b0f265b&scoped=true&"
import script from "./grant.vue?vue&type=script&lang=js&"
export * from "./grant.vue?vue&type=script&lang=js&"
import style0 from "./grant.vue?vue&type=style&index=0&id=3b0f265b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0f265b",
  null
  
)

export default component.exports